import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-dark-DEFAULT border-t border-dark-border" data-id="element-102">
      <div className="max-w-3xl mx-auto text-center" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-dark-card border border-brand-DEFAULT p-8 md:p-12 rounded-2xl relative overflow-hidden" data-id="element-104">
          {/* Background glow */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-brand-DEFAULT/10 rounded-full blur-3xl pointer-events-none" data-id="element-105"></div>

          <div className="relative z-10 flex flex-col items-center" data-id="element-106">
            <div className="bg-dark-DEFAULT p-4 rounded-full border border-dark-border mb-6" data-id="element-107">
              <ShieldCheckIcon size={48} className="text-brand-DEFAULT" data-id="element-108" />
            </div>

            <div className="inline-block bg-dark-border text-white font-bold px-4 py-1 rounded-full text-sm mb-6 flex items-center space-x-2" data-id="element-109">
              <span data-id="element-110">🛡️</span>
              <span data-id="element-111">Garantía EDULABS 7 días</span>
            </div>

            <h2 className="text-3xl md:text-4xl font-bebas mb-4" data-id="element-112">
              <span className="text-white" data-id="element-113">Garantía EDULABS </span>
              <span className="text-brand-DEFAULT" data-id="element-114">7 días sin preguntas</span>
            </h2>

            <p className="text-lg text-text-secondary mb-6" data-id="element-115">
              Abre los 6 tomos. Revisa los 6 bonos. Úsalos en la sesión si
              quieres.
            </p>

            <p className="text-white mb-6 font-medium" data-id="element-116">
              Si en 7 días no es lo que esperabas te devolvemos el 100%. Sin
              preguntas. Sin formularios. Sin drama.
            </p>

            <p className="text-sm text-brand-gold italic font-bold" data-id="element-117">
              DATO: La tasa de devoluciones es menor al 1%.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}